export const getParameterByName = (name, url) => {
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/**
 * Process a downloaded file. 
 * Will open a 'Save file as' modal for the user
 * @param {string} fileName 
 * @param {string} fileType 
 * @param {*} data 
*/
export const processDownloadedFile = (fileName, fileType, data) => {
  let file = new Blob([data], {type: `application/${fileType}`})
  let fileURL = URL.createObjectURL(file)

  let a = document.createElement('a')
  a.href = fileURL
  a.target = '_blank'
  a.download = fileName + `.${fileType}`
  document.body.appendChild(a)
  a.click()
}

 /**
 * @param {string} token 
 * @returns {any} decoded token
 */
export const decodeJWT = (token) => {
  //JWTs come in three base64 encoded sections in a guaranteed order
  // 1) Header
  // 2) Payload
  // 3) signature
  // We need to pull the email from the payload for this
  const jwtSections = token.split('.');
  if(jwtSections.length !== 3) {
    console.error("JWT had invalid number of sections!")
    return '';
  }
  return JSON.parse(Buffer.from((jwtSections[1]), 'base64'));
}

